export const scheduleCols = () => {
  return [
    {
      headerName: "Event",
      field: "event",
      width: 150,
      editable: false,
    },
    {
      headerName: "Match",
      field: "match_number",
      width: 150,
      editable: false,
    },
    {
      headerName: "Robot Slot",
      field: "robot_slot",
      width: 150,
      editable: false,
      renderCell: (params) => (
        <div>
          {(params.value.includes("red") ? "Red " : "Blue ") +
            params.value.replace("red", "").replace("blue", "")}
        </div>
      ),
    },
    {
      headerName: "Robot #",
      field: "robot",
      width: 150,
      editable: false,
    },
    {
      headerName: "ETA",
      field: "eta",
      width: 150,
      editable: false,
      renderCell: (params) => (
        <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {params.value}
        </div>
      ),
    },
  ];
};
